import { DefaultHttpClient, HttpRequest, HttpResponse, HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert'; 
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../../../app/hooks';
import { RootState } from '../../../app/store';
import Errors from '../../../components/errors';
import Loader from '../../../components/loader';
import { getFeatureToggles, enableFeatureToggle } from '../../../services/featureTogglesSlice';
import List from './list';
import getConfig from "../../../app/config";
import auth from '../../../components/auth';
import { createAsyncThunk } from '@reduxjs/toolkit';

const ListFeatureToggles = ({setBorehole}:any) => {    
  const dispatch = useAppDispatch();

  useEffect(() => {
    setBorehole(null);
    dispatch(getFeatureToggles());
  },[]);  

  const selectAccount = (state: RootState) => state.featureToggles;
  const { 
    featureToggles,
    featureTogglesLoading,    
    error
  } = useSelector(selectAccount); 

    const onEnable = (featureToggleId: string, featureToggleName: string) => {
      confirmAlert({
          title: 'Confirm Enable Feature Toggle',
          message: `Are you sure you want to enable feature toggle ${featureToggleName}?`,
          buttons: [
            {
              label: 'Yes',
              onClick: () => {
                dispatch(enableFeatureToggle({featureToggleId}));
              }
            },
            {
              label: 'No',
              onClick: () => {}
            }
          ]
        });        
  };

    
    return (
        <section className="section">
            <div>
                <div className='columns'>
                  <div className="column">
                    <h1>Feature Toggles</h1>   
                  </div>                  
                </div>                

                {(featureTogglesLoading) && <Loader/>}
                <Errors error={error}/>
                
                <List featureToggles={featureToggles} 
                      onEnable={onEnable} 
                          />                
            </div>
        </section>
    )    
};

export default ListFeatureToggles;